import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

type Step = { step: string; title: string; desc: string };

export default function CTASection() {
  const { t } = useTranslation();
  const steps = t("process.steps", { returnObjects: true }) as Step[];

  return (
    <>
      <section className="py-24 bg-[#E4E5EC]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-20">
            <span
              className="text-[#8A7A6A] block leading-none mb-2"
              style={{ fontFamily: "'Great Vibes', cursive", fontSize: "38px" }}
            >
              {t("process.calligraphy")}
            </span>
            <h2
              className="text-[#1E202A]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(28px, 3.5vw, 44px)", fontWeight: 300 }}
            >
              {t("process.title1")} <em>{t("process.title2")}</em>
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0">
            {Array.isArray(steps) && steps.map((s, i) => (
              <div
                key={i}
                className={`py-8 ${i > 0 ? "lg:pl-10 lg:border-l border-[#D0D1DB]" : ""} ${i === 1 ? "sm:pl-10 sm:border-l" : ""}`}
              >
                <span
                  className="text-[#8A7A6A]/20 leading-none select-none block mb-4"
                  style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "52px", fontStyle: "italic", fontWeight: 300 }}
                >
                  {s.step}
                </span>
                <h3
                  className="text-[#1E202A] mb-3"
                  style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "19px", fontWeight: 500 }}
                >
                  {s.title}
                </h3>
                <p className="text-[#74758A] text-sm leading-[2]">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-28 bg-[#D9DAE5]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-3xl mx-auto text-center relative">
            <span
              className="absolute inset-0 flex items-center justify-center text-[#1E202A]/[0.04] select-none pointer-events-none leading-none"
              style={{ fontFamily: "'Great Vibes', cursive", fontSize: "200px" }}
            >
              Legacy
            </span>
            <div className="relative z-10">
              <span
                className="text-[#8A7A6A] block leading-none mb-3"
                style={{ fontFamily: "'Great Vibes', cursive", fontSize: "clamp(36px, 5vw, 52px)" }}
              >
                {t("process.finalCalligraphy")}
              </span>
              <h2
                className="text-[#1E202A] leading-tight mb-6"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(30px, 4vw, 50px)", fontWeight: 300 }}
              >
                {t("process.finalTitle1")}
                <br />
                <em>{t("process.finalTitle2")}</em>
              </h2>
              <div className="w-10 h-px bg-[#8A7A6A]/40 mx-auto mb-6" />
              <p className="text-[#74758A] text-sm leading-[2] mb-10 max-w-xl mx-auto">
                {t("process.finalDesc")}
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 bg-[#1E202A] text-[#EDEEF3] px-10 py-4 rounded-full text-sm font-medium hover:bg-[#8A7A6A] transition-all duration-300 cursor-pointer whitespace-nowrap"
                  style={{ letterSpacing: "0.03em" }}
                >
                  {t("process.finalCta1")}
                  <i className="ri-arrow-right-line" />
                </Link>
                <a
                  href="tel:+13177012768"
                  className="inline-flex items-center gap-2 border border-[#C8C9D4] text-[#1E202A] px-10 py-4 rounded-full text-sm hover:border-[#8A7A6A] hover:text-[#8A7A6A] transition-all cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-line" />
                  {t("process.finalCta2")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
